site.pageImage = {
	init:function() {
		$('label', '#elm_page_galleryImageId .lmnt').each(function() {
			var $this = $(this),
				url = $this.text();
			$this.html($this.html().replace(url, '<img alt="" src="//placehold.it/1" class="responsive" data-src="'+url+'" />'));
		});

		$('#page-tabs').on('tabsactivate', function(event, ui) {
			if (ui.newTab.index() == 3) {
				$("img.responsive").responsiveImg();
			}
		});
	}
};

site.inits.push('site.pageImage.init()');
